import React from "react";
import { Helmet } from "@dr.pogodin/react-helmet";

const SITE_URL = "https://www.eveness.ai";
const DEFAULT_IMAGE = `${SITE_URL}/logo.svg`;

const SEO = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
}) => {
  const fullTitle = title || "Eveness";
  const canonicalUrl = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>

      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO;
